import React, { useEffect, useState } from 'react';
import styles from '../../css/style.module.css';
import HOC from '../../components/HOC/HOC';
import { useNavigate } from 'react-router-dom';
import { DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import { deleteApi, getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import img2 from '../../assest/loading1.gif';
import { FaPlus } from 'react-icons/fa6';
import { RiDeleteBin6Line } from 'react-icons/ri';

const columns = ['S.no', 'Name', 'Email', 'Phone', 'Status', 'Action'];

const getCachedUserType = () => {
  try {
    const cached = JSON.parse(localStorage.getItem('adminData') || '{}');
    return cached?.data?.userType || cached?.userType || '';
  } catch {
    return '';
  }
};

const normalizeSubAdminList = response => {
  const data = response?.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.docs)) return data.docs;
  return [];
};

const SubAdmin = () => {
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (getCachedUserType() === 'SUB_ADMIN') {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  const fetchData = async () => {
    await getApi(endPoints.getSubAdmins, {
      setResponse: response => setData(normalizeSubAdminList(response)),
      setLoading,
      errorMsg: 'Failed to fetch sub-admins!',
    });
  };

  useEffect(() => {
    if (getCachedUserType() === 'SUB_ADMIN') return;
    fetchData();
  }, []);

  const handleDelete = async () => {
    if (!selectedId) return;

    await deleteApi(endPoints.deleteSubAdmin(selectedId), {
      setLoading,
      errorMsg: 'Failed to delete sub-admin!',
    });

    fetchData();
    setShowDeleteModal(false);
    setShowSuccessModal(true);
    setTimeout(() => setShowSuccessModal(false), 2000);
  };

  const openDeleteModal = id => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };

  const getName = item => {
    const full = `${item?.firstName || ''} ${item?.lastName || ''}`.trim();
    return full || item?.fullName || 'N/A';
  };

  return (
    <>
      <DeleteSuccessfullyModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleConfirm={handleDelete}
        text="delete this sub-admin"
      />
      <SuccessfullyModal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        text="Successfully Deleted"
      />
      <div className={styles.jobmanagementCotainer}>
        <div className={styles.jobtoppart}>
          <div className={styles.pagetitle}>
            <h6>Sub Admin</h6>
          </div>
          <div className={styles.rightbuttons}>
            <div
              className={styles.rightbuttons2}
              onClick={() => navigate('/sub-admin/add')}
            >
              <FaPlus color="#FFFFFF" />
              <p>Add New</p>
            </div>
          </div>
        </div>
        <div className={styles.jobchildcontainer}>
          <div className={styles.tablecontainer}>
            <table className={styles.table1}>
              <thead>
                <tr>
                  {columns.map((label, index) => (
                    <th key={index} className={styles.tableHeader}>
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center', padding: '1rem' }}>
                      <img src={img2} alt="Loading" width={100} height={100} />
                    </td>
                  </tr>
                ) : data.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center', padding: '1rem' }}>
                      No data available.
                    </td>
                  </tr>
                ) : (
                  data.map((item, rowIndex) => (
                    <tr key={item._id || rowIndex} className={styles.tableRow}>
                      <td className={styles.tableCell}>{rowIndex + 1}</td>
                      <td className={styles.tableCell}>{getName(item)}</td>
                      <td className={styles.tableCell}>{item.email || 'N/A'}</td>
                      <td className={styles.tableCell}>{item.phone || 'N/A'}</td>
                      <td className={styles.tableCell}>{item.status || 'N/A'}</td>
                      <td>
                        <div className={styles.tableaction}>
                          <RiDeleteBin6Line
                            size={20}
                            onClick={() => openDeleteModal(item._id)}
                            style={{ cursor: 'pointer', color: '#d9534f' }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default HOC(SubAdmin);
